import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab', 'panel']

  className () {
    return this.element.dataset.classname
  }

  connect () {
    // this.showTab(0)
  }

  changeTab (event) {
    event.preventDefault()
    const index = this.tabTargets.indexOf(event.currentTarget)

    this.showTab(index)
  }

  showTab (index) {
    this.tabTargets.forEach(tab => tab.classList.remove(`${this.className()}::active`))
    this.panelTargets.forEach(panel => panel.classList.remove(`${this.className()}::active`))

    this.tabTargets[index].classList.add(`${this.className()}::active`)
    this.panelTargets[index].classList.add(`${this.className()}::active`)
  }
}
